import { Box, Container, Grid, styled, Typography } from "@mui/material";
import { AboutUsImage, Page } from "components";
import { PreviewAppBar } from "layouts";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { globalStyles } from "styles";
import bannerImage from "../../../assets/img/banner_tentang_kami.png";
import Layout from "../../../mpisLandingComponent/Layout";

const PreviewAboutUs = () => {
  const classes = globalStyles();
  const { webManagement } = useSelector(data => data);
  const [payload, setPayload] = useState({
    about_us: "",
    our_vision: "",
    about_us_images: [],
    our_vision_images: [],
    publisher_images: [],
  });
  const {
    about_us,
    our_vision,
    about_us_images,
    our_vision_images,
    publisher_images,
  } = payload;

  useEffect(() => {
    setPayload(webManagement);
  }, [webManagement]);

  return (
    <Page title="Preview">
      <PreviewAppBar />
      <Layout>
        <Container maxWidth={"xxl"} sx={{ my: "-90px" }}>
          <BannerContainer>
            <Box maxWidth="60%">
              <Typography fontSize={48} fontWeight={600} mb={2}>
                About Us
              </Typography>
              <Typography color="#687083">
                <Box dangerouslySetInnerHTML={{ __html: about_us }} />
              </Typography>
            </Box>
          </BannerContainer>
          <Box mx="-24px" py="24px" height={648} bgcolor="#f9fafb">
            <Grid container columnSpacing={2} columns={24} height="100%">
              <Grid item xs={7} height="100%">
                <img
                  alt="banner"
                  src={publisher_images?.[0]?.image_url}
                  className={classes?.aboutUsImageGallery}
                />
              </Grid>
              <Grid item xs={10}>
                <Grid container rowGap={2}>
                  <Grid item xs={12} height={394}>
                    <img
                      alt="banner"
                      src={publisher_images?.[1]?.image_url}
                      className={classes?.aboutUsImageGallery}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container columnSpacing={2} height={190}>
                      <Grid item xs={6} height="100%">
                        <img
                          alt="banner"
                          src={publisher_images?.[2]?.image_url}
                          className={classes?.aboutUsImageGallery}
                        />
                      </Grid>
                      <Grid item xs={6} height="100%">
                        <img
                          alt="banner"
                          src={publisher_images?.[3]?.image_url}
                          className={classes?.aboutUsImageGallery}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={7}>
                <Grid container direction="column" rowGap={2} height="100%">
                  <Grid item height={190}>
                    <img
                      alt="banner"
                      src={publisher_images?.[4]?.image_url}
                      className={classes?.aboutUsImageGallery}
                    />
                  </Grid>
                  <Grid item height={394}>
                    <img
                      alt="banner"
                      src={publisher_images?.[5]?.image_url}
                      className={classes?.aboutUsImageGallery}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box mx="6vw" my="32px">
            <Grid container direction="row" columnSpacing={4}>
              <Grid item xs={12} md={6}>
                {about_us_images?.map(({ image_url }, index) => (
                  <AboutUsImage
                    key={index}
                    image_url={image_url}
                    index={index}
                  />
                ))}
              </Grid>
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Box>
                  <Typography fontSize={32} fontWeight={600} mb={1}>
                    About Us
                  </Typography>
                  <Typography color="#687083">
                    <Box dangerouslySetInnerHTML={{ __html: about_us }} />
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box mx="6vw" my="32px">
            <Grid container direction="row" columnSpacing={4}>
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Box>
                  <Typography fontSize={32} fontWeight={600} mb={1}>
                    Our Vision
                  </Typography>
                  <Typography color="#687083">
                    <Box dangerouslySetInnerHTML={{ __html: our_vision }} />
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                {our_vision_images?.map(({ image_url }, index) => (
                  <AboutUsImage
                    key={index}
                    image_url={image_url}
                    index={index}
                  />
                ))}
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Layout>
    </Page>
  );
};

const BannerContainer = styled(Box)({
  backgroundImage: `url(${bannerImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "515px",
  display: "flex",
  alignItems: "center",
  padding: "0 64px",
});
export default PreviewAboutUs;
